<template>
  <div id="navWrapper">
    <div id="navContainer">
      <div id="serial">
        <a href="https://www.chanchao.com.tw/ExhibitorServiceTW/en"
          >Chan Chao Exhibitor's Online Service System</a
        >
      </div>
      <ul id="quickLink">
        <li class="indexList" v-if="!ExhiListPage">
          <a href="https://www.chanchao.com.tw/ExhibitorServiceTW/en"
            >Exhibition List</a
          >
        </li>
        <li class="langTw">
          <a class="pointer" @click="toCnVersion">中文版</a>
        </li>
        <li class="logout">
          <a href="/apiLogin2/Logout"><span name="Company"></span>Logout</a>
        </li>
      </ul>

      <ul id="quickMbLink" v-if="ExhiListPage">
        <li class="langTw">
          <a href="https://www.chanchao.com.tw/ExhibitorServiceTW/">
            <img src="../assets/images/langTW.svg" width="20px" alt="" />
          </a>
        </li>
        <li class="logout mx-2">
          <a
            href="/apiLogin2/Logout"
            onclick=' return confirm("請確認要登出？");'
          >
            <img src="../assets/images/logout.svg" width="20px" alt="" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ExhiListPage: false,
      getUrl: "",
    };
  },

  methods: {
    toCnVersion() {
      const vm = this;
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW${vm.getUrl}`;
    },
  },

  created() {
    const vm = this;
    let nowPage = location.href;
    let activePage = nowPage.split("/")[5];
    if (!activePage) {
      vm.ExhiListPage = true;
    } else {
      vm.ExhiListPage = false;
    }

    vm.getUrl = nowPage.split("/en")[1];
    // console.log(vm.getUrl)
  },
};
</script>

<style lang="scss">
#navContainer {
  width: 100%;
  height: 40px;
  background-color: #000;
  position: fixed;
  top: 0;
  z-index: 99;
  color: #fff;
  font-size: 14px;
}

ul#quickLink li.lang a {
  background-image: url(../assets/images/lang.svg);
}
ul#quickLink li.member a {
  background-image: url(../assets/images/member.svg);
}

ul#quickLink li.logout a {
  background-image: url(../assets/images/logout.svg);
}

ul#quickLink li.langTw a {
  background-image: url(../assets/images/langTW.svg);
}
ul#quickLink li.indexList a {
  background-image: url(../assets/images/indexList.svg);
}

ul#quickLink {
  position: absolute;
  right: 5%;
  top: 12px;
}

ul#quickMbLink {
  display: none;
}

ul#quickLink li {
  float: left;
  width: auto;
  margin-left: 20px;
  vertical-align: middle;
  list-style-type: none;
}
ul#quickLink li a {
  display: block;
  background-position: left center;
  background-repeat: no-repeat;
  background-size: 16px 16px;
  padding-left: 20px;
  line-height: 16px;
  text-decoration: none;
  color: #fff;
  opacity: 0.7;
}
ul#quickLink li a:hover {
  opacity: 1;
}

ul {
  text-decoration: none;
}

#serial a {
  color: #ffffff;
}

#serial {
  width: 100%;
  position: absolute;
  left: 5%;
  top: 0;
  height: 40px;
  line-height: 40px;
  background-image: url(../assets/images/favicon.png);
  background-repeat: no-repeat;
  background-size: 16px 16px;
  background-position: left center;
  padding-left: 20px;
}

@media screen and (max-width: 800px) {
  #serial {
    top: 5px;
  }

  ul#quickMbLink {
    display: flex;
    position: absolute;
    right: 0;
    top: 17px;
    vertical-align: middle;
  }

  ul#quickMbLink a {
    color: rgb(255, 255, 255);
  }

  #quickMbLink li {
    padding-right: 7px;
    opacity: 0.7;
    text-decoration: none;
  }
}
</style>
